module.exports = __webpack_public_path__ + "static/img/img_welecome.830d2cf9.png";